
(function () {
  'use strict';

  if (window.VWL) {
    window.VWL._sync();
    return;
  }

  /* ── Storage key — scoped per customer when logged in ── */
  var custId = (window.__WL_CUST && window.__WL_CUST !== 0) ? String(window.__WL_CUST) : '';
  var KEY       = custId ? ('vtu_wl_' + custId) : 'vtu_wl';
  var GUEST_KEY = 'vtu_wl';

  /* On login: merge any wishlisted items the customer added as a guest */
  if (custId && KEY !== GUEST_KEY) {
    try {
      var guestRaw = localStorage.getItem(GUEST_KEY);
      if (guestRaw) {
        var guestItems = JSON.parse(guestRaw) || [];
        if (guestItems.length) {
          var existing = JSON.parse(localStorage.getItem(KEY) || '[]');
          var merged = existing.slice();
          guestItems.forEach(function (g) {
            if (!merged.some(function (e) { return String(e.id) === String(g.id); })) {
              merged.push(g);
            }
          });
          localStorage.setItem(KEY, JSON.stringify(merged));
        }
        localStorage.removeItem(GUEST_KEY);
      }
    } catch (e) {}
  }

  /* ── Storage ── */
  function getItems() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }

  function saveItems(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('wishlist:change', { detail: { count: items.length, items: items } }));
  }

  function has(id) {
    var sid = String(id);
    return getItems().some(function (i) { return String(i.id) === sid; });
  }

  function count() { return getItems().length; }

  function add(id, handle) {
    var sid = String(id);
    var items = getItems();
    if (!items.some(function (i) { return String(i.id) === sid; })) {
      saveItems(items.concat([{ id: sid, handle: handle }]));
    }
  }

  function remove(id) {
    var sid = String(id);
    saveItems(getItems().filter(function (i) { return String(i.id) !== sid; }));
  }

  function toggle(id, handle) {
    if (has(id)) { remove(id); return false; }
    add(id, handle); return true;
  }

  /* ── Sync header badge ── */
  function syncBadge(n) {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n > 0 ? n : '';
      el.hidden = n === 0;
    });
  }

  /* ── Sync all wishlist buttons ── */
  function syncButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id    = btn.dataset.productId;
      var added = has(id);
      btn.setAttribute('aria-pressed', String(added));
      btn.classList.toggle('wishlist-btn--active', added);
      var label = btn.querySelector('.wishlist-btn__text');
      if (label) label.textContent = added ? btn.dataset.labelRemove : btn.dataset.labelAdd;
    });
  }

  function _sync() {
    syncBadge(count());
    syncButtons();
  }

  window.VWL = { getItems: getItems, has: has, count: count, add: add, remove: remove, toggle: toggle, _sync: _sync };

  /* ── Click handler ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var id     = btn.dataset.productId;
    var handle = btn.dataset.productHandle;
    if (!id || !handle) return;

    var added = toggle(id, handle);
    btn.setAttribute('aria-pressed', String(added));
    btn.classList.toggle('wishlist-btn--active', added);
    var labelEl = btn.querySelector('.wishlist-btn__text');
    if (labelEl) labelEl.textContent = added ? btn.dataset.labelRemove : btn.dataset.labelAdd;
  });

  /* ── React to wishlist changes ── */
  window.addEventListener('wishlist:change', function (e) {
    syncBadge(e.detail.count);
    syncButtons();
  });

  /* ── Initial sync ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _sync);
  } else {
    _sync();
  }

  /* ── Re-sync on Shopify theme editor events ── */
  document.addEventListener('shopify:section:load', _sync);
  document.addEventListener('shopify:block:select', _sync);
})();
